import {
  GENDER_OPTION_ALL,
  GENDER_OPTION_FEMALES,
  GENDER_OPTION_MALES
} from '../../../../../ReusableFormFields/GenderFields/fields'

export const getGenderOption = targeting => {
  if (
    targeting.find(item => item.gender === 'GENDER_MALE') &&
    targeting.find(item => item.gender === 'GENDER_FEMALE')
  ) {
    return GENDER_OPTION_ALL
  }

  if (targeting.find(item => item.gender === 'GENDER_MALE')) {
    return GENDER_OPTION_MALES
  }

  if (targeting.find(item => item.gender === 'GENDER_FEMALE')) {
    return GENDER_OPTION_FEMALES
  }

  return null
}
